export default {
      id: "doctor-usage",
      viewBox: "0 0 29 33",
      url: __webpack_public_path__ + "sprite.svg#doctor",
      toString: function () {
        return this.url;
      }
    }